import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _ref3;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchGetVillageSuggests } from '../../Repositories/countryside-search/v1/get-village-suggests';
export var getVillageSuggests = function getVillageSuggests(_x, _x2) {
  return (_ref3 = _ref3 || _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, _ref2) {
    var name, httpApi, logger, _yield$fetchGetVillag, response, statusCode;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          name = _ref.name;
          httpApi = _ref2.httpApi, logger = _ref2.logger;
          _context.prev = 2;
          _context.next = 5;
          return fetchGetVillageSuggests({
            httpApi: httpApi,
            parameters: {
              name: name
            }
          });
        case 5:
          _yield$fetchGetVillag = _context.sent;
          response = _yield$fetchGetVillag.response;
          statusCode = _yield$fetchGetVillag.statusCode;
          if (!(statusCode !== 200 || !response.suggests)) {
            _context.next = 10;
            break;
          }
          return _context.abrupt("return", []);
        case 10:
          return _context.abrupt("return", response.suggests.filter(function (_ref4) {
            var id = _ref4.id,
              name = _ref4.name,
              address = _ref4.address;
            return Boolean(id && name && address);
          }));
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](2);
          logger.error(_context.t0, {
            description: "Failed to load villages",
            meta: {
              name: name
            }
          });
          return _context.abrupt("return", []);
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 13]]);
  }))).apply(this, arguments);
};